globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.Radio = (function () {

  Radio.selector = '[data-plugin="limitless.radio"], [data-plugin="limitless.radio.zones"]';

  Radio.init = function ($html) {
    $html.find(Radio.selector).each(function () {
      new Radio($(this));
    })

    // Handle with-opacity class
    $html.find('label.with-opacity').each(function(){
      if(!$(this).find('input').is(':checked') && $(this).find('input').attr('type') === 'radio') {
        $(this).addClass('unchecked');
      }
    })

    $html.find('label.with-opacity').on('change', 'input[type=radio]', function(){
      var $this = $(this);
      var name = $this.attr('name');

      // Update ALL radio buttons with the same name
      $html.find('label.with-opacity input[name="' + name + '"]').each(function() {
        var $radio = $(this);
        var $radioContainer = $radio.closest('label.with-opacity');

        ($radio.is(':checked')) ? $radioContainer.removeClass('unchecked') : $radioContainer.addClass('unchecked');
      });
    });
  }


  function Radio($html) {
    this.$html = $html;
    this.init();
  }

  Radio.prototype = {
    init: function () {
      var _this = this;

      if (_this.$html.is(':input')) {
        _this.initInput(_this.$html);
      }

      if (_this.$html.find("input").length) {
        _this.$html.find("input").each(function () {
          _this.initInput($(this));
        })
      }

      if (_this.$html.find(".radio-zone").length) {
        _this.setCheckedZones();
        _this.zoneEvents();
      }
    },
    initInput: function ($input) {
      $input.uniform({
        radioClass: 'choice'
      });
    },
    zoneEvents: function () {
      var _this = this;

      _this.$html.on("change", "input", function () {
        _this.setCheckedZones();
      })
    },
    setCheckedZones: function () {
      var _this = this;

      _this.$html.find(".radio-zone").each(function () {
        var $zone = $(this);
        if ($zone.find("input").is(":checked")) {
          $zone.addClass("checked");
        } else {
          $zone.removeClass("checked");
        }
      });
    }
  }

  return Radio;

})();
